import { addComponentToDOMById } from '$serverSrc/utils/component'

import EnterprisePage from './components/EnterprisePage'
import ToolsPage from './components/ToolsPage'
import UsersPage from './components/UsersPage'

import './index.scss'

class App {
  constructor() {
    addComponentToDOMById(EnterprisePage, 'Enterprise')
    addComponentToDOMById(ToolsPage, 'Tools')
    addComponentToDOMById(UsersPage, 'Users')
  }
}

// Always export a 'new' instance so it immediately evokes:
export default new App()
